/**
 * Formats a number as currency
 * @param value The value to format
 * @param currency The currency code (e.g. 'BRL', 'USD')
 * @returns Formatted currency string
 */
export const formatCurrency = (value: number, currency: string = 'BRL'): string => {
  try {
    // Default to 'pt-BR' for BRL, otherwise use 'en-US'
    const locale = currency === 'BRL' ? 'pt-BR' : 'en-US';
    
    return new Intl.NumberFormat(locale, {
      style: 'currency',
      currency: currency,
      minimumFractionDigits: 2,
      maximumFractionDigits: 2
    }).format(value);
  } catch (error) {
    // Fallback in case of error
    console.error('Error formatting currency:', error);
    return `${currency} ${value.toFixed(2)}`;
  }
}; 